export default {
  item: {},
  list: [],
  total: 0,
  searchList: [],
  errors: [],
  hasErrors: false,
  fetching: false,
  fetched: false,
  updating: false,
  updated: false,
  updatingMultiple: false,
  updatedMultiple: false,
  fetchingOne: false,
  fetchedOne: false,
  deleting: false,
  deleted: false,
  searching: false,
  searched: false,
  creating: false,
  created: false,
  clearingFromStateFinished: false,
};
